import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'
import Interests from '../components/Interests'
import TalePreview from '../components/TalePreview'
import Exp from '../components/Exp'
import ProjectList from '../components/ProjectList'

const HomeIndex = () => {

    return (
        <Layout>
            <Helmet
                title="Natália Ritzmann"
                meta={[
                    { name: 'robots', content: 'index, follow' },
                    { name: 'description', content: 'Natália Ritzmann' },
                    { name: 'keywords', content: 'portifolio, natalia ritzmann, ritzmann, natalia, comunicacao, comunicação, redatora, redação, redacao ' },
                ]}
            >
            </Helmet>

            <Banner />

            <div id="main">

                <Interests />

                <Exp />

                <ProjectList />

                <TalePreview />

            </div>
        </Layout>
    )
}
export default HomeIndex